import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=30d1182a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d1182a')) {
      api.createRecord('30d1182a', component.options)
    } else {
      api.reload('30d1182a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=30d1182a&", function () {
      api.rerender('30d1182a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZEvfgtQtQ2nZ/JS/cancellationPolicy.vue"
export default component.exports